module.exports = __webpack_public_path__ + "./fonts/mplus-1c-regular.otf";